import type { RouteObject } from 'react-router'
import { ROUTES } from '@/shared/routes'
import { LoginCallbackPage } from './LoginCallbackPage'
import { LoginPage } from './LoginPage'

/** Pages for signed-out visitors; the app wraps them in `PublicRoute`. */
export const authRoutes: RouteObject[] = [
  { path: ROUTES.LOGIN, element: <LoginPage /> },
  { path: ROUTES.LOGIN_CALLBACK, element: <LoginCallbackPage /> },
]
